
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import config from './../../config';
import {styleHeader2} from './../../styles';


class PanelController extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.private = cloneObject(this.blueprint.private);


    }

    reset(blueprint, renderer=null){
        this.private = cloneObject(blueprint.private);
        
        super.reset(blueprint, renderer);
        
    }

    getTitle(){
        return this.data.title || '';
    }

    getChildren(){
        return this.private.children || [];
    }


}


let PanelBlueprint = extend({
    type: PanelController,
    properties: {
        style: { 
            width: (ctrl) => ( (state.get('renderSize') == 'medium')? '46%': 'auto'),
            padding: (ctrl) => ( (state.get('renderSize') == 'medium')? '0% 2%': '0px'),
            display: (ctrl) => ( (state.get('renderSize') == 'medium')? 'inline-block': 'block'),
            verticalAlign: 'top'
         }
    },
    private: {
        children: []
    },
    children: [
        (parent) => (extend({
            properties:{
                style: cloneObject(styleHeader2),
                content: parent.getTitle()
            }
        }, Group) ),

        (parent) => (extend({
            properties: {
                style: {
                    border: '1px solid #d3d3d3',
                    padding: '10px 15px'
                },
                data: extend({}, parent.data)
            },
            children: parent.getChildren()
        }, Group) )
    ]
}, Group)


export default PanelBlueprint;
export {PanelController, PanelBlueprint};
